import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import Select from 'react-select'
import InfiniteScroll from 'react-infinite-scroll-component'
import { getSpecificUser } from '../../store/actions/apiActions'
import AnimationLayout from '../../components/AnimationLayout'
import Button from '../../components/Button'
import Loading from '../../components/Loading'
import { getFirestore } from 'redux-firestore'

const AllUsersList = () => {
    const [state, setState] = useState({
        resultsPerPage: 12,
        isLoading: false,
        error: false,
        usersLength: [],
        list: [],
        ref: null,
        last: null,
        filterType: '',
        filterMethod: ''
    })

    const dispatch = useDispatch()
    const { list, isLoading, error, usersLength } = state
    const db = getFirestore()

    useEffect(() => {
        getAllUsersLength()
    }, [])

    useEffect(() => {
        getUsers()
    }, [state.filterMethod])

    const getAllUsersLength = () => {
        db.collection("counters").doc('users').get()
            .then(item => {
                const requestNumber = item.data()
                console.log(requestNumber)
                const getNumber = requestNumber.number
                setState({ ...state, usersLength: getNumber })
            })
            .catch(err => setState({ ...state, err: err }))
    }

    const getUsers = () => {
        setState({ ...state, isLoading: true })
        let requestUsers
        const { filterType, filterMethod } = state
        if (filterType) {
            if (filterMethod && (filterMethod === 'desc' || filterMethod === 'asc')) {
                requestUsers = db.collection("users").limit(state.resultsPerPage).orderBy(`${filterType}`, `${filterMethod}`)
            }
        } else {
            requestUsers = db.collection("users").limit(state.resultsPerPage).orderBy('createdAt', 'desc')
        }

        requestUsers.get()
            .then((documentSnapshots) => {
                let lastVisible = documentSnapshots.docs[documentSnapshots.docs.length - 1]
                const list = []
                documentSnapshots.forEach((doc) => {
                    let { username, avatar, level, statute } = doc.data();
                    list.push({ key: doc.id, username, avatar, level, statute });
                });
                setState({ ...state, ref: requestUsers, list, last: lastVisible, isLoading: false });
            })
            .catch((err) => setState({ ...state, error: err }))
    }

    const fetchMoreData = () => {
        let addNextUsers = []
        let lastUser = state.last
        state.ref.startAfter(lastUser).get()
            .then((documentSnapshots) => {
                let lastVisible = documentSnapshots.docs[documentSnapshots.docs.length - 1];
                documentSnapshots.forEach((doc) => {
                    let { username, avatar, level, statute } = doc.data();
                    addNextUsers.push({ key: doc.id, username, avatar, level, statute });
                })
                setState({ ...state, list: state.list.concat(addNextUsers), lastUser: lastVisible });
            })
            .catch((err) => setState({ ...state, error: err }))
    }

    const updateFilter = (ev, { action }, filter) => {
        if (action === 'clear' && filter === 'filterMethod') {
            setState({ ...state, [filter]: null })
            getUsers()
        } else {
            setState({ ...state, [filter]: ev?.value ? ev?.value : '' })
        }
    }

    const typeOptions = [
        { value: 'createdAt', label: 'Data de criação' },
        { value: 'username', label: 'Nome' },
        { value: 'level', label: 'Nível' },
    ]

    const methodOptions = [
        { value: 'asc', label: 'Ascendente' },
        { value: 'desc', label: 'Descendente' }
    ]

    return (
        <AnimationLayout>
            <h1>Lista de utilizadores</h1>
            <div className='white-container py-4'>
                <p>Filtrar utilizadores por:</p>
                <div className='grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-0 lg:gap-8'>
                    <Select
                        options={typeOptions}
                        isClearable={true}
                        isSearchable={false}
                        placeholder='Selecione a forma de filtrar'
                        className='block appearance-none shadow appearance-none rounded w-full my-3'
                        onChange={(ev, { action }) => updateFilter(ev, { action }, 'filterType')}
                        classNamePrefix='react-select'
                        aria-label='Menu de formas de filtragem'
                        aria-labelledby='Formas de filtragem'
                    />

                    <Select
                        isDisabled={!state.filterType ? true : false}
                        options={methodOptions}
                        isClearable={true}
                        isSearchable={false}
                        placeholder='Selecione o método de filtragem'
                        className='block appearance-none shadow appearance-none rounded w-full my-3'
                        onChange={(ev, { action }) => { updateFilter(ev, { action }, 'filterMethod') }}
                        classNamePrefix='react-select'
                        aria-label='Menu de métodos de filtragem'
                        aria-labelledby='Método de filtragem'
                    />

                </div>
            </div>

            {/* <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12 mb-12 justify-center items-center'>
                {!isLoaded(userDocs) ? <Loading /> :
                    isEmpty(userDocs) ? <p className='pt-4 pb-8'>Ainda não existem utilizadores registados no adventour ou ocorreu um erro no pedido à base de dados!</p> :
                        userDocs.length === 10 && userDocs.map((item, index) =>
                            <Link
                                key={index}
                                to={`/comunidade/perfil/${item.username}`}
                                onClick={() => dispatch(getSpecificUser(item.username))}
                            >
                                <Button className='image-button usable mr-0 h-full'>
                                    <div className='py-4'>
                                        <img
                                            alt={item.avatar}
                                            className='object-contain h-32 mx-auto pb-2'
                                            src={require(`../../assets/img/matilde-faces/${item.avatar}.png`)}
                                        />
                                        <h3>{item.username}</h3>
                                        <div className='text-left px-2'>
                                            <p>Nível: {item.level}</p>
                                            <p>Estatuto: {item.statute}</p>
                                        </div>
                                    </div>
                                </Button>
                            </Link>
                        )}
            </div> */}



            {isLoading ? <Loading /> :
                error ? <p>Ocorreu um erro no pedido dos utilizadores à base de dados, tenta novamente mais tarde!</p> :
                    <InfiniteScroll
                        dataLength={list.length}
                        next={() => fetchMoreData()}
                        hasMore={list.length === usersLength.length ? false : true}
                        loader={<Loading />}>
                        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12 mb-12 justify-center items-center'>
                            {list.map((item, index) => (
                                <Link
                                    key={index}
                                    to={`/comunidade/perfil/${item.username}`}
                                    onClick={() => dispatch(getSpecificUser(item.username))}
                                >
                                    <Button className='image-button usable mr-0 h-full'>
                                        <div className='py-4'>
                                            <img
                                                alt={item.avatar}
                                                className='object-contain h-32 mx-auto pb-2'
                                                src={require(`../../assets/img/matilde-faces/${item.avatar}.png`)}
                                            />
                                            <h3>{item.username}</h3>
                                            <div className='text-left px-2'>
                                                <p>Nível: {item.level}</p>
                                                <p>Estatuto: {item.statute}</p>
                                            </div>
                                        </div>
                                    </Button>
                                </Link>
                            ))}
                        </div>
                    </InfiniteScroll>
            }




            {/*             <div className='flex flex-wrap justify-center md:justify-between mb-10'>
                <Button
                    className='mr-0'
                    disabled={page <= 1 || currentUsers < resultsPerPage ? true : false}
                    onClick={() => page > 1 ? handleButtonNextPrevious('previous') : null}
                >
                    Página Anterior
                </Button>
                <Button
                    className='mr-0'
                    disabled={currentUsers < resultsPerPage ? true : false}
                    onClick={() => handleButtonNextPrevious('next')}
                >
                    Proxima Página
                </Button>
            </div> */}
        </AnimationLayout>
    )
}

export default AllUsersList